import { AxiosResponse } from 'axios'
import { FTimestamp } from '@playback-rewards/shared-libraries'

import axiosWebInstance from 'axiosWebInstance'

export const getUTCTime = (): Promise<AxiosResponse<FTimestamp, Error>> =>
  axiosWebInstance.get('/api/v1/utc-time')
